exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.panelHolder.closed[data-v-e85d8218] {\n  max-height: 0;\n  overflow: hidden;\n}\n.radios[data-v-e85d8218] {\n  height: 70px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-e85d8218","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/inventory/products/components/MinMaxManager.vue
// module id = 1637
// module chunks = 0